<template lang="pug">
  .w-full.p-10.flex.justify-between.items-center
    //- (spacer md)
    .hidden.md-block.w-150.flex-shrink-0
    //- msg
    p.text-13.text-left.md-text-center(style="max-width:45em")
      slot(name="text")
    //- accept
    .flex-shrink-0.w-110.md-w-150.text-13.leading-none
      slot(name="button")
      //- button.flex-shrink-0.w-110.md-w-150.h-82.flex.items-center.justify-center.text-13.border.leading-none.hover-text-app-text.hover-border-current.trans-fast(@click="accept") Accept

  //- COOKIE BANNER
  //- .w-full.bg-white.p-10.flex.justify-between.items-center.border-b.md-border-b-0.md-border-t(v-if="!acceptedCookies && policyLink")
    //- (spacer md)
    .hidden.md-block.w-150.flex-shrink-0
    //- msg
    .text-13(style="max-width:42em")
      | We are using cookies to offer a better online experience. You can read our <wp-link :link="policyLink" class="hover-text-app-text">cookies policy</wp-link>
    //- accept
    button.flex-shrink-0.w-110.md-w-150.h-82.flex.items-center.justify-center.text-13.border.leading-none.hover-text-app-text.hover-border-current.trans-fast(@click="accept") Accept
</template>

<script>
export default {
  name: 'Banner'
}
</script>

<style>
</style>
